import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ActionAlerts from './ActionAlerts';
import ClientProvider from './client';
export default createDemo(import.meta.url, ActionAlerts, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/alert/demos/action/ActionAlerts.tsx",
    "fileName": "ActionAlerts.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Alert from '@mui/material/Alert';\nimport Button from '@mui/material/Button';\nimport Stack from '@mui/material/Stack';\n\nexport default function ActionAlerts() {\n  return (\n    <Stack sx={{ width: '100%' }} spacing={2}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Alert severity=\"warning\" onClose={() => {}}>\n        This Alert displays the default close icon.\n      </Alert>\n      <Alert\n        severity=\"success\"\n        action={\n          <Button color=\"inherit\" size=\"small\">\n            UNDO\n          </Button>\n        }\n      >\n        This Alert uses a Button component for its action.\n      </Alert>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 23,
        "focusedLines": 13,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Alert from '@mui/material/Alert';\nimport Button from '@mui/material/Button';\nimport Stack from '@mui/material/Stack';\n\nexport default function ActionAlerts() {\n  return (\n    <Stack sx={{ width: '100%' }} spacing={2}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Alert severity=\"warning\" onClose={() => {}}>\n        This Alert displays the default close icon.\n      </Alert>\n      <Alert\n        severity=\"success\"\n        action={\n          <Button color=\"inherit\" size=\"small\">\n            UNDO\n          </Button>\n        }\n      >\n        This Alert uses a Button component for its action.\n      </Alert>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "warning",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "onClose"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "() ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " {}",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            "        This Alert displays the default close icon."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "success",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "action"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "inherit",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "size"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            "            UNDO"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "          </",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            "      >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            "        This Alert uses a Button component for its action."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 23,
    "focusedLines": 13,
    "collapsible": true,
    "externals": [
      "@mui/material/Alert",
      "@mui/material/Button",
      "@mui/material/Stack"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
